import repository from "../Repository";

export default {
  async list(screenId) {
    return await repository.post("car/car-operator-list", {
      headers: {
        s: screenId
      }
    });
  },
  async entry(screenId, payload) {
    return await repository.post("car/car-operator-entry", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async update(screenId, payload) {
    return await repository.post("car/car-operator-update", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async delete(screenId, payload) {
    return await repository.post("car/car-operator-delete", payload, {
      headers: {
        s: screenId
      }
    });
  }
};
